import styled from 'styled-components';

export const ForgotText = styled.p`
  color: ${(props) => props.theme.colors.gray.six};
  font-size: 18px;
  margin-top: 11px;
`;
